import { render, staticRenderFns } from "./VippsPayment.vue?vue&type=template&id=3084b238&"
import script from "./VippsPayment.vue?vue&type=script&lang=js&"
export * from "./VippsPayment.vue?vue&type=script&lang=js&"
import style0 from "./VippsPayment.vue?vue&type=style&index=0&id=3084b238&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports